import { SeverityMapper } from '../../../common/mappers/SeverityMapper';
import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { Issue } from '../models/Issue';

export class IssueMapper {
  private readonly gqlIdEncoder = new GQLIdEncoder();
  private readonly severityMapper = new SeverityMapper();

  mapGQLModel(data: any): Issue {
    return new Issue(
      data.number,
      data.title,
      data.shortExplanation ?? '',
      this.severityMapper.mapSeverity(data.severity),
      data.filterStatus,
      this.gqlIdEncoder.decode(data.reportId),
      data.instances ? data.instances.edges.map((edge: any) => this.gqlIdEncoder.decode(edge.node.id)) : []
    );
  }
}
